
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/opportunities/submissions",
      function () {
        return require("private-next-pages/opportunities/submissions/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/opportunities/submissions"])
      });
    }
  